/* global JsCallbackToHarmony */
(function(w) {
    let harmony = {};
    harmony.navigateTo = function({ url = ''} = {}) {
        if(!url) {
            console.warn('url parameter error!')
            return false;
        }
        return callMethods({methodName: 'navigateTo', params: {url}})
    }

    harmony.navigateBack = function() {
        return callMethods({methodName: 'navigateBack', params: {}})
    }

    harmony.redirectTo = function({ url = "" } = {}) {
        if(!url) {
            console.warn('url parameter error!')
            return false;
        }
        return callMethods({methodName: 'redirectTo', params: {url}})
    }

    harmony.switchTab = function({ url = "" } = {}) {
        if(!url) {
            console.warn('url parameter error!')
            return false;
        }
        return callMethods({methodName: 'switchTab', params: {url}})
    }

    w.harmony = harmony;
    function callMethods({methodName = "", params = {}} = {}) {
        if (!w.JsCallbackToHarmony) throw new Error('[ENV Error] Please open in Harmony App!');
        const data = {
            name: methodName,
            data: params
        }
        const dataString = JSON.stringify(data)
        return w.JsCallbackToHarmony.call(dataString)
    }
})(window);
